<main class="maintenance">
    <div class="logo"></div>
    <div class="maintenance__title">
        <h1>We're busy improving your experience.</h1>
    </div>
    <p>We'll be back up and running shortly.<br />Please check back soon!</p>
    <span>
        For questions, comments, or concerns, please
        <a href="mailto:info@secured.team">reach out</a>.
    </span>
</main>

<div class="cogs">
    <div *ngFor="let c of cogs"><i class="fas fa-cog"></i></div>
</div>
